import React, { Component } from 'react'
import PropTypes from 'prop-types'
import interact from 'interact.js'
import styled from 'styled-components'

import ResizeAnchors from 'components/common/ResizeAnchors'

export const Container = styled.div`
  position: fixed;
  border-style: ${props => props.editMode ? 'dashed' : 'solid'};
  border-width: 2px;
  pointer-events: ${props => props.pointerEvents};
  z-index: 2;
  ${props => props.overlayStyle}
  ${props => props.transparent ? 'border-width: 0px; background-color: transparent;' : ''}
`

class StyledOverlay extends Component {

  componentDidMount () {
    this.htmlElement = document.querySelector('html')
    const { canMove, canResize } = this.props
    if (this.overlayRef) {
      let draggable = { enabled: false }
      let resizable = { enabled: false }
      if (canMove) {
        draggable = {
          onstart: this.onDragStart,
          onmove: this.onDragMove,
          onend: this.onDragEnd,
        }
      }
      if (canResize) {
        resizable = {
          preserveAspectRatio: true,
          margin: 7, // distance form bound to define resizing-action area of mouse cursor
          edges: { left: true, right: true, bottom: true, top: true },
          onstart: this.onResizeStart,
          onmove: this.onResizeProgress,
          onend: this.onResizeEnd,
        }
      }
      interact(this.overlayRef).draggable(draggable).resizable(resizable)
    }
  }

  onResizeStart = e => {
    const { getInitialZoom } = this.props
    this.initialZoom = 1
    this.initialWidth = e.rect.width
    const initialZoomValue = getInitialZoom()
    if (initialZoomValue) this.initialZoom = initialZoomValue
    this.setState({menuVisible: false})
  }

  onResizeProgress = e => {
    const { updateZoomLocally } = this.props
    this.currentWidth = e.rect.width
    updateZoomLocally({ zoom: this.initialZoom * this.currentWidth / this.initialWidth })
  }

  onResizeEnd = e => {
    const { updateZoom } = this.props
    updateZoom({ zoom: this.initialZoom * this.currentWidth / this.initialWidth })
    e.target.style.transform = ''
  }

  onDragStart = () => {
    const { getInitialPosition } = this.props
    this.initialX = 0
    this.initialY = 0
    this.currentX = 0
    this.currentY = 0
    this.rem = parseFloat(this.htmlElement.style.fontSize)

    const initialPosition = getInitialPosition()
    if (initialPosition) {
      this.initialX = initialPosition.x
      this.initialY = initialPosition.y
    }
  }

  onDragMove = e => {
    // console.log('onDragMove', e)
    const { updatePositionLocallySimple } = this.props
    this.currentX += e.dx / this.rem
    this.currentY += e.dy / this.rem
    updatePositionLocallySimple({ x: this.initialX + this.currentX, y: this.initialY + this.currentY })
  }

  onDragEnd = e => {
    const { updatePosition } = this.props
    updatePosition({ x: this.initialX + this.currentX, y: this.initialY + this.currentY })
    e.target.style.marginLeft = '0'
    e.target.style.marginTop = '0'
  }

  onContainerMounted = (ref) => {
    this.overlayRef = ref
  }

  render () {
    const { style, overlayStyle, canMove, canResize, transparent, resizeAnchorsVisible } = this.props
    return (
      <Container
        style={style}
        overlayStyle={overlayStyle}
        editMode={canMove}
        transparent={transparent}
        innerRef={this.onContainerMounted}
      >
        <ResizeAnchors visible={resizeAnchorsVisible && canResize} size={6} />
      </Container>
    )
  }
}

StyledOverlay.defaultProps = {
  style: {},
  overlayStyle: '',
  transparent: false,
  resizeAnchorsVisible: false,
  getInitialPosition: () => null,
  updatePositionLocallySimple: () => null,
  updatePosition: () => null,
  canMove: false,
  canResize: false,
  getInitialZoom: () => null,
  updateZoomLocally: () => null,
  updateZoom: () => null
}

StyledOverlay.propTypes = {
  style: PropTypes.object,
  overlayStyle: PropTypes.string,
  transparent: PropTypes.bool,
  resizeAnchorsVisible: PropTypes.bool,
  getInitialPosition: PropTypes.func,
  updatePositionLocallySimple: PropTypes.func,
  updatePosition: PropTypes.func,
  canMove: PropTypes.bool,
  canResize: PropTypes.bool,
  getInitialZoom: PropTypes.func,
  updateZoomLocally: PropTypes.func,
  updateZoom: PropTypes.func
}


export default StyledOverlay



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/overlay/StyledOverlay.js